import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { IoArrowBackOutline } from 'react-icons/io5';
import { BsFileEarmarkExcel, BsFileEarmarkPdf } from 'react-icons/bs';
import { query, collection, onSnapshot, orderBy, where } from "firebase/firestore";
import { db } from './../../../../firebase';
import OutletHead from '../../../../components/common/outlet-head';
import TransactionDataTable from '../../../../components/ledger/transaction-datatables';
import { useAuth } from '../../../../context/AuthContext';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';

function Transactions() {

  const { user } = useAuth();
  const { bid } = user.claims;
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  const transactionTableRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);

  const pdfOptions = {
    resolution: Resolution.HIGH,
    page: { margin: Margin.SMALL },
    overrides: { pdf: { compress: true } }
  };

  async function getLedger(partyID) {
    const q = query(collection(db, "Businesses", bid, "Ledger"), where("partyID", "==", partyID), orderBy("transactionDate"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      var totalBalanceAmount = 0;
      var tempData = [];
      querySnapshot.forEach((doc) => {
        if (doc.data().creditAmount && parseFloat(doc.data().creditAmount) > 0) {
          totalBalanceAmount = parseFloat(totalBalanceAmount) + parseFloat(doc.data().creditAmount);
          tempData.push({ txnID: doc.id, ...doc.data(), isBooking: true, narration: doc.data().narration, balanceAmount: totalBalanceAmount });
        } else {
          totalBalanceAmount = parseFloat(totalBalanceAmount) - parseFloat(doc.data().debitAmount);
          tempData.push({ txnID: doc.id, ...doc.data(), isBooking: false, description: `Receipt No. ${doc.data().receiptID}`, narration: doc.data().narration, balanceAmount: totalBalanceAmount });
        }
      });

      setData(tempData);
    }, (error) => {
      console.log(error.message);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    if (state && state.id) {
      getLedger(state.id);
    }
  }, [state]);

  let filename = state.partyName;
  filename = filename.replace(/ /g, "-");
  let today = Date.now();
  filename = filename + '-' + today;

  return (
    <section className='section'>
      <OutletHead
        left={
          <div className='d-flex align-items-center'>
            <Button
              variant='light'
              size='sm'
              className='p-2 me-3 rounded-circle'
              onClick={() => navigate(-1)}
            >
              <IoArrowBackOutline size={24} />
            </Button>
            <h5 className='mb-0'>{state && state.partyName}</h5>
          </div>
        }
        right={
          <div className='d-flex align-items-center'>
            <DownloadTableExcel
              filename={`${filename}-LEDGER`}
              sheet="Party Ledger"
              currentTableRef={transactionTableRef.current}
            >
              <Button
                variant="outline-primary"
                className='py-2 px-4'
              >
                <BsFileEarmarkExcel size={18} />
                <span className='ps-2'>Export Excel</span>
              </Button>
            </DownloadTableExcel>
            <Button
              variant="outline-primary"
              className='py-2 px-4 ms-3'
              onClick={() => generatePDF(transactionTableRef, pdfOptions, { filename: `${filename}.pdf` })}
            >
              <BsFileEarmarkPdf size={18} />
              <span className='ps-2'>Export PDF</span>
            </Button>
          </div>
        }
      />
      <div className='p-3 border-top'>
        <div className='row'>
          <div className='col-lg-12'>
            <TransactionDataTable
              columns={["Date", "Particular", "Mode of Payment", "Debit (₹)", "Credit (₹)", "Balance (₹)"]}
              data={data}
              ref={transactionTableRef}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Transactions;
